import { select } from "d3";
import { getTextHeight } from "./Canvas2DContext";
import { DefaultConfigs } from "./DefaultConfigs";

const BR_TAGS = /<br(?:(?:\s*)?\/?)?>/ig;
const NO_BREAK_TAGS = /<\/?no-break>/ig;
const SUP_TAG = /<sup>(.*)?<\/sup>/i;
const SUB_TAG = /<sub>(.*)?<\/sub>/i;

const SUP_ATTR_VALUE = "5px";
const SUB_ATTR_VALUE = "-4px";

export default class TickLabelFormatService {
  static processNoBreak(text) {
    return text.replace(NO_BREAK_TAGS, "");
  }

  static processTag(textContent, parentNode, tagRegexp, attributeValue) {
    if (tagRegexp.test(textContent)) {
      const supTextContent = tagRegexp.exec(textContent)[1];

      // Removing it from the original string
      textContent = textContent.replace(tagRegexp, "");

      if (parentNode) {
        parentNode.append("tspan")
          .attr("baseline-shift", attributeValue)
          .text(TickLabelFormatService.processNoBreak(supTextContent));
      } else {
        textContent += `<tspan baseline-shift="${attributeValue}">${TickLabelFormatService.processNoBreak(supTextContent)}</tspan>`;
      }
    }

    return textContent;
  }

  static preFormatTickLabel(text, font) {
    const lines = text
      .toString()
      .split(BR_TAGS)
      .map(s => s.trim());

    const extraSpace = SUP_TAG.test(text.toString()) ? DefaultConfigs.LabelSpaceForSup : 0;

    // `Sample` here was intentional. It has "S" and "p", forcing
    // both extremes of the font to be evaluated
    const textHeight = getTextHeight(font, "Sample", extraSpace);

    // Tricky! We need to shift back the "dy" attribute as many pixels as the font requires
    // for the first item *only*, the remaining items need to use `i * textHeight`
    const firstDY = -(textHeight * (lines.length - 1));

    let formattedLabel = "";

    lines.forEach((line, i) => {
      line = TickLabelFormatService.processTag(line, null, SUB_TAG, SUB_ATTR_VALUE);
      line = TickLabelFormatService.processTag(line, null, SUP_TAG, SUP_ATTR_VALUE);
      line = TickLabelFormatService.processNoBreak(line);

      const dy = i > 0 ? i * textHeight : firstDY;

      formattedLabel += `<tspan x="0" dy="${dy}">${line}</tspan>`;
    });

    return formattedLabel;
  }

  static postFormatTickLabel(tickTexts, initialY) {
    tickTexts.each(function () {
      const text = select(this);
      const lines = text.text()
        .split(BR_TAGS)
        .map(s => s.trim());

      text.text(null);

      lines.forEach((line) => {
        const extraSpace = SUP_TAG.test(line) ? DefaultConfigs.TickLabelExtraSpaceForSup : 0;
        const dy = initialY != null && initialY + extraSpace;

        const tspan = text.append("tspan")
          .attr("x", 0)
          .attr("dy", `${dy}`);

        line = TickLabelFormatService.processTag(line, text, SUP_TAG, SUP_ATTR_VALUE);
        line = TickLabelFormatService.processTag(line, text, SUB_TAG, SUB_ATTR_VALUE);
        line = TickLabelFormatService.processNoBreak(line);

        tspan.text(line);
      });
    });
  }
}
